// Copied from https://github.com/sutoiku/formula.js/blob/master/lib/financial.js

function nper(rate, payment, present, future = 0, type = 0) {
  const num = payment * (1 + rate * type) - future * rate;
  const den = (present * rate + payment * (1 + rate * type));
  return Math.log(num / den) / Math.log(1 + rate);
}

export default nper
